import type {
	EarlyFreedomContext,
	EarlyFreedomGoalPreset,
} from "web_myplann/Inspiration/EarlyFreedom/Types/EarlyFreedomTypes";
import { getEarlyFreedomTargetYears } from "web_myplann/Inspiration/EarlyFreedom/Utils/getEarlyFreedomTargetYears";

export const mapEarlyFreedomGoalPreset = (
	context: EarlyFreedomContext,
): EarlyFreedomGoalPreset => {
	const years = getEarlyFreedomTargetYears(context);
	const now = new Date();

	return {
		monthlyRent: context.gap,
		dueDate: new Date(now.getFullYear() + years, now.getMonth(), 1),
	};
};
